import { render, staticRenderFns } from "./ProjectUsersTagsManager.vue?vue&type=template&id=4aab490a&scoped=true"
import script from "./ProjectUsersTagsManager.vue?vue&type=script&lang=ts"
export * from "./ProjectUsersTagsManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab490a",
  null
  
)

export default component.exports